import React, { useEffect, useState } from 'react';
import ListView from '../../components/views/listView';
import { MasterMessage } from '../../../masters/masterMessages';
import { useNavigate } from 'react-router-dom';
import { HOME, USEREDIT, USERNEW } from '../../../routes/paths';
import { useSelector } from 'react-redux';
import { Chip, Tooltip, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import Swal from 'sweetalert2';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { RootState } from '../../../redux/store';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';
import {
    asyncDeleteUser,
    asyncGetUsers,
} from '../../../services/users.service';

const UserList = () => {
    const navigate = useNavigate();
    const { logUser } = useSelector((state: RootState) => state.general);
    const { id: idUserLog } = logUser || {};
    const [rows, setRows] = useState<any>();
    const [lengthRows, setLengthRows] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(20);
    const {
        titleList,
        titleInactive,
        messageInactive,
        messageInactiveOk,
        messageInactiveError,
    } = MasterMessage.users;
    const { users }: any = MasterMessage;

    useEffect(() => {
        asyncGetUsers(page, pageSize)
            .then((body: any) => {
                if (body.items !== undefined) {
                    setRows(body.items.items);
                    setLengthRows(body.items.length);
                } else if (body.message !== undefined) {
                    SwalCustomClass.fire({
                        text: users[body.message],
                        icon: 'error',
                        iconColor: '#1d1d1d',
                    });
                }
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, users]);

    const deleteUser = (row: any) => {
        Swal.fire({
            title: titleInactive,
            text: messageInactive,
            icon: 'error',
            iconColor: '#1d1d1d',
            showDenyButton: true,
            denyButtonText: 'NO',
            denyButtonColor: '#1d1d1d',
            confirmButtonText: 'SI',
            confirmButtonColor: '#1d1d1d',
            customClass: 'swal-wide-class',
        }).then((response) => {
            if (response.isConfirmed) {
                asyncDeleteUser(row.id).then((body: any) => {
                    if (body.items !== undefined) {
                        SwalCustomClass.fire({
                            text: messageInactiveOk,
                            icon: 'success',
                            iconColor: '#1d1d1d',
                        });
                        asyncGetUsers(page, pageSize).then((body: any) => {
                            if (body.items !== undefined) {
                                setRows(body.items.items);
                                setLengthRows(body.items.length);
                            }
                        });
                    } else {
                        SwalCustomClass.fire({
                            text: messageInactiveError,
                            icon: 'error',
                            iconColor: '#1d1d1d',
                        });
                    }
                });
            }
        });
    };

    const paginator = (paginationModel: any) => {
        if (paginationModel.page !== page) {
            setPage(paginationModel.page);
        } else if (paginationModel.pageSize !== pageSize) {
            setPageSize(paginationModel.pageSize);
        }
    };

    const columns = [
        {
            field: 'code',
            headerName: 'Código',
            minWidth: 120,
            flex: 0.4,
        },
        {
            field: 'name',
            headerName: 'Nombre',
            minWidth: 150,
            flex: 0.6,
        },
        {
            field: 'surname',
            headerName: 'Apellido',
            minWidth: 150,
            flex: 0.6,
        },
        {
            field: 'username',
            headerName: 'Correo',
            minWidth: 150,
            flex: 0.8,
        },
        {
            field: 'type',
            headerName: 'Pérfil',
            minWidth: 120,
            flex: 0.5,
        },
        {
            field: 'status',
            headerName: 'Estado',
            minWidth: 100,
            flex: 0.5,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row: any) => {
                if (row.row.status === true) {
                    return (
                        <Chip
                            label="ACTIVO"
                            sx={{ ml: 1, fontSize: 11.5 }}
                            color="success"
                        />
                    );
                } else {
                    return (
                        <Chip
                            label="INACTIVO"
                            sx={{ ml: 1, fontSize: 11.5 }}
                            color="error"
                        />
                    );
                }
            },
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row: any) => (
                <>
                    <Tooltip title="Editar">
                        <IconButton
                            size="small"
                            onClick={() => navigate(`${USEREDIT}/${row.id}`)}
                        >
                            <EditIcon type="submit" color="primary" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Deshabilitar">
                        <span>
                            <IconButton
                                size="small"
                                onClick={() => deleteUser(row)}
                                disabled={
                                    idUserLog === row.id || !row.row.status
                                }
                            >
                                <PersonOffIcon
                                    type="submit"
                                    color={
                                        idUserLog === row.id || !row.row.status
                                            ? 'disabled'
                                            : 'primary'
                                    }
                                />
                            </IconButton>
                        </span>
                    </Tooltip>
                </>
            ),
        },
    ];

    return (
        <ListView
            title={titleList}
            titleButtonAdd={'Agregar'}
            startIconButtonAdd={<AddCircleIcon color="secondary" />}
            onClickAdd={() => navigate(USERNEW)}
            onClickBack={() => navigate(HOME)}
            columns={columns}
            rows={rows}
            rowCount={lengthRows}
            disableRow={true}
            loading={loading}
            onSetPage={(paginationModel: any) => paginator(paginationModel)}
        />
    );
};

export default UserList;
